import { useCallback, useEffect, useSyncExternalStore } from 'react'

const MOBILE_BREAKPOINT = 640
const QUERY = `(max-width: ${MOBILE_BREAKPOINT}px)`

/**
 * Detects mobile viewport using matchMedia.
 * SSR-safe: returns false during server rendering.
 * Updates reactively when viewport crosses the 640px breakpoint.
 */
export function useIsMobile(): boolean {
  const subscribe = useCallback((callback: () => void) => {
    if (typeof matchMedia === 'undefined') return () => {}

    const mql = matchMedia(QUERY)
    mql.addEventListener('change', callback)
    return () => mql.removeEventListener('change', callback)
  }, [])

  const getSnapshot = useCallback(() => {
    if (typeof matchMedia === 'undefined') return false
    return matchMedia(QUERY).matches
  }, [])

  const getServerSnapshot = useCallback(() => false, [])

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
